import React from 'react';
import PropTypes from 'prop-types';
import {Icon} from 'semantic-ui-react';
import {Modal as BootstrapModal} from 'react-bootstrap';

import {Button} from 'Common/Structure';

import './modal.scss';

const Modal = ({
  children,
  className,
  closeText,
  closeable,
  closeOnBackdropClick,
  destructive,
  footer,
  isLoading,
  onClose,
  onSubmit,
  show,
  size,
  submitButtonClassName,
  submitButtonDisabled,
  submitText,
  title,
  ...props
}) => {
  const dismissOnBackdropClick =
    closeOnBackdropClick === undefined ? closeable : closeOnBackdropClick;

  const originalFooter = (
    <BootstrapModal.Footer>
      <Button disabled={isLoading} floated="left" neutral onClick={onClose}>
        {closeText}
      </Button>

      <Button
        className={submitButtonClassName}
        disabled={submitButtonDisabled || isLoading}
        loading={isLoading}
        negative={destructive}
        onClick={onSubmit}
        primary={!destructive}
      >
        {submitText}
      </Button>
    </BootstrapModal.Footer>
  );

  return (
    <BootstrapModal
      animation={false}
      backdrop={dismissOnBackdropClick ? true : 'static'}
      backdropClassName="mhd--modal--backdrop"
      bsSize={size}
      className={`mhd--modal mhd--center ${className}`}
      keyboard={closeable}
      onHide={onClose}
      show={show}
      {...props}
    >
      <BootstrapModal.Header className="text-left">
        {closeable && (
          <div className="mhd--modal--close">
            <a className="close" onClick={onClose}>
              <Icon
                inverted
                link
                name="close"
                size="small"
                style={{textShadow: 'none'}}
              />
              <span className="sr-only">Close</span>
            </a>
          </div>
        )}

        <BootstrapModal.Title>{title}</BootstrapModal.Title>
      </BootstrapModal.Header>

      <BootstrapModal.Body>{children}</BootstrapModal.Body>

      {footer || originalFooter}
    </BootstrapModal>
  );
};

Modal.defaultProps = {
  children: null,
  className: '',
  closeText: 'Cancel',
  closeable: false,
  closeOnBackdropClick: undefined,
  destructive: false,
  footer: null,
  isLoading: false,
  onSubmit: null,
  show: false,
  size: 'sm',
  submitButtonClassName: '',
  submitButtonDisabled: false,
  submitText: 'Submit',
  title: '',
};

Modal.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  closeText: PropTypes.string,
  closeable: PropTypes.bool,
  closeOnBackdropClick: PropTypes.bool,
  destructive: PropTypes.bool,
  footer: PropTypes.node,
  isLoading: PropTypes.bool,
  show: PropTypes.bool,
  size: PropTypes.string,
  submitButtonClassName: PropTypes.string,
  submitButtonDisabled: PropTypes.bool,
  submitText: PropTypes.node,
  title: PropTypes.string,

  // functions
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
};

export default Modal;



// WEBPACK FOOTER //
// ./src/components/Common/Structure/Modal.js